import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "statusText"
})
export class StatusPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    var HeaderText = "";


    switch (Math.trunc(value / 10)) {
      case 0:
        HeaderText = "Neu";
        break;
      case 1:
        HeaderText = "Zuzahlungspflichtig";
        break;
      case 2:
        HeaderText = "eKV";
        break;
      case 3:
        HeaderText = "Leitstelle";
        break;
      case 4:
        HeaderText = "Versand";
        break;
      case 5:
        HeaderText = "INBR";
        break;
      case 20:
        HeaderText = "In Abrechnung";
        break;
      case 80:
        HeaderText = "Retoure";
        break;
      case 90:
        HeaderText = "Beendet / Abgelehnt";
        break;
    }

    if (value == 55) {
      HeaderText = "Unvollständig";
    }

    if (value == 100) {
      HeaderText = "Gerätetausch";
    }

    if (value == 999) {
      HeaderText = "Archive";
    }
    if (value == 900) {
      HeaderText = "Abgeschlossen";
    }
    if (value == 901) {
      HeaderText = "eKV Abgelehnt";
    }
    if (value == 902) {
      HeaderText = "Widerruf Kunde";
    }

    if (value == 15) {
      HeaderText = "Zuzahlung erhalten";
    }
    if (value == 21) {
      HeaderText = "eKV Rückläufer";
    }

    if (value == 25) {
      HeaderText = "eKV Klärung";
    }

    if (value == 26) {
      HeaderText = "Wellcome Call";
    }

    if (value == -999) {
      HeaderText = "In Klärung";
    }
    if (value == 201) {
      HeaderText = "In Abrechnung (Bearbeitung)";
    }



    return `${HeaderText} (${value})`;

    return value;
  }
}
